import { ReviewListPage } from '~/components/Reviews/ReviewListPage'
import ReviewsFullSection from '~/components/Reviews/ReviewsFullSection'

export default function ReviewsPage() {
  return (
    <ReviewListPage>
      <ReviewsFullSection />
    </ReviewListPage>
  )
}